import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ComponentCatalogGroup, ComponentService} from '../../services/component.service';

@Component({
  selector: 'cc-component-list',
  templateUrl: './component-list.component.html',
  styleUrls: ['./component-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentListComponent implements OnInit {
  groups = new Map<string, ComponentCatalogGroup>();

  constructor(private readonly componentService: ComponentService) {
  }

  ngOnInit() {
    this.groups = this.componentService.getGroups();
  }
}
